module.exports = __webpack_public_path__ + "static/img/duyao.167030a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/man/product/duyao.jpg
// module id = uC7o
// module chunks = 0